export default __webpack_public_path__ + "static/404-2d8e9e06f372c2d55d31673ae7871175.svg";